import React, { Component } from 'react'
import NumberFormat from "react-number-format";
import { connect } from 'react-redux'
import $ from 'jquery';
import { createPaymentPages } from '../../../state/ducks/payment/types';
import { binSearch, addPaymentPayTr, getPaymentPlaneEminPay, binSearchEminPay } from "../../../services/payment.service";
import {
    EminPayPageLayout,
    getEminPayTypeLabel,
} from "./EminPayPaymentUi";
import EminPayServiceAlert from "./EminPayServiceAlert";
import EminPayCustomSelect from "./EminPayCustomSelect";

function ValidateCreditCardNumber() {

    var ccNum = document.getElementById("cardNo").value.replace(/\D/g, '');
    var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
    var amexpRegEx = /^(?:3[47][0-9]{13})$/;
    var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
    var troyRegEx = /^(?:9[0-9]{12}(?:[0-9]{3})?)$/;
    var isValid = false;

    if (visaRegEx.test(ccNum)) {
        isValid = true;
    } else if (mastercardRegEx.test(ccNum)) {
        isValid = true;
    } else if (amexpRegEx.test(ccNum)) {
        isValid = true;
    } else if (discovRegEx.test(ccNum)) {
        isValid = true;
    } else if (troyRegEx.test(ccNum)) {
        isValid = true;
    }

    if (isValid) {
        return true;
    } else {
        return false;
    }
}



export class CreditCardEminPay extends Component {

    state = {
        // cc_owner: "EminPay TEST",
        // card_number: "4355084355084358",
        // expiry_month: "12",
        // expiry_year: "30",
        // cvv: "000",
        // card_type: "axess",


        cc_owner: "",
        card_number: "",
        expiry_month: "",
        expiry_year: "",
        cvv: "",
        card_type: "",
        bank: "",
        bankCode: "",
        businessCard: "",

        installment_count: 0,

        uyeno_hatamesaj: "",
        cardAdi_hatamesaj: "",
        cardNo_hatamesaj: "",
        cardTarih_hatamesaj: "",
        cardCvv_hatamesaj: "",

        installment_list: [],

        amount: 0.00,

        page: "creditCard",
        smsResponse: "",
        error: "",
        shouldAnimateCard: false,
    };

    onSubmit = e => {
        e.preventDefault();
        if (this.formKontrol() == 0) {
            return false;
        }

        this.cardAddPaymentEminPay();
    }

    formKontrol() {
        var cardAdi = $("#cardAdi").val();
        var cardNo = $("#cardNo").val();
        const { creditcard } = this.props;
        var cardTarih = creditcard.expirationMonth;
        var cardTarihYıl = creditcard.expirationYear;
        var cardCvv = $("#cardCvv").val();
        var durum = 1;
        // kuruş alanı boş ise kuruş 00 olduğu kabul edilir. O sebep ile kontrol dışı.
        // var patternCredit = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        // var sdurum = patternCredit.test(cardNo.replace(/\D/g, ''));
        // Card Adı boş mu dolu mu ?


        if (cardAdi == "") {
            durum = 0; // Konu Boş
            $("#cardAdi").parent().addClass("t-error");
            $("#cardAdi").next().html("<i class='t-icon-error text-danger'></i>");
            // $("#cardAdi_hatamesaj").html("Kart Adı alanı boş bırakılamaz.");
            this.setState({ cardAdi_hatamesaj: "Kart Adı alanı boş bırakılamaz." });

        } else {
            $("#cardAdi").parent().removeClass("t-error");
            $("#cardAdi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
            // $("#cardAdi_hatamesaj").html("");
            this.setState({ cardAdi_hatamesaj: "" });
        }
        // Card No boş mu dolu mu ?
        if (cardNo == "") {
            durum = 0; // Konu Boş
            $("#cardNo").parent().addClass("t-error");
            $("#cardNo").next().html("<i class='t-icon-error text-danger'></i>");
            // $("#cardNo_hatamesaj").html("Kart Numarası alanı boş bırakılamaz.");
            this.setState({ cardNo_hatamesaj: "Kart Numarası alanı boş bırakılamaz." });
        } else {
            if (ValidateCreditCardNumber() == false) {
                durum = 0;
                $("#cardNo").parent().addClass("t-error");
                $("#cardNo").next().html("<i class='t-icon-error text-danger'></i>");
                // $("#cardNo_hatamesaj").html("Kart Numarasını kontrol ediniz.");
                this.setState({ cardNo_hatamesaj: "Kart Numarasını kontrol ediniz." });
            }
            else {

                $("#cardNo").parent().removeClass("t-error");
                $("#cardNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
                // $("#cardNo_hatamesaj").html("");
                this.setState({ cardNo_hatamesaj: "" });
            }
        }
        // Card Tarih boş mu dolu mu ?
        if (cardTarih == "" || cardTarihYıl == "") {
            durum = 0; // Konu Boş

            $("#cardExpiry-wrap").addClass("t-error");
            $("#cardExpiry_status").html("<i class='t-icon-error text-danger'></i>");
            this.setState({ cardTarih_hatamesaj: "Tarih alanı boş bırakılamaz." });
        } else {
            $("#cardExpiry-wrap").removeClass("t-error");
            $("#cardExpiry_status").html("<i class='t-icon-check_circle_outline text-success'></i>");
            this.setState({ cardTarih_hatamesaj: "" });
        }

        const cardCvvNumber = cardCvv.replace(' ', '');
        // Card CVV boş mu dolu mu ?
        if (cardCvv == "") {
            durum = 0; // Konu Boş
            $("#cardCvv").parent().addClass("t-error");
            $("#cardCvv").next().html("<i class='t-icon-error text-danger'></i>");
            // $("#cardCvv_hatamesaj").html("CVV alanı boş bırakılamaz.");
            this.setState({ cardCvv_hatamesaj: "CVV alanı boş bırakılamaz." });
        } else if (cardCvvNumber.length < 3) {
            durum = 0; // Konu Boş
            $("#cardCvv").parent().addClass("t-error");
            $("#cardCvv").next().html("<i class='t-icon-error text-danger'></i>");
            // $("#cardCvv_hatamesaj").html("CVV alanı boş bırakılamaz.");
            this.setState({ cardCvv_hatamesaj: "CVV alanı 3 karakterden oluşmalıdır." });
        } else {
            $("#cardCvv").parent().removeClass("t-error");
            $("#cardCvv").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
            // $("#cardCvv_hatamesaj").html("");
            this.setState({ cardCvv_hatamesaj: "" });
        }

        const { orderdetail } = this.props;
        if (orderdetail.paymentType == 2 && orderdetail.installmentCount < 2 && this.state.installment_list.length > 0) {
            durum = 0; // Taksit seçilmemiş
            this.setState({ installmentCount_hatamesaj: "Ödeme planından taksit seçeneğini seçiniz." });
        } else {
            this.setState({ installmentCount_hatamesaj: "" });
        }

        return durum;

    }

    cardNoControl(_bank, _bankCode, _businessCard, _card_type, _message, _isError) {

        this.setState({ card_type: _card_type });
        this.setState({ bank: _bank });
        this.setState({ bankCode: _bankCode.toString() });
        this.setState({ businessCard: _businessCard });
        this.cardgetPaymentPlaneEminPay();

        if (_isError == true) {
            $("#cardNo").parent().addClass("t-error");
            $("#cardNo").next().html("<i class='t-icon-error text-danger'></i>");
            this.setState({ cardNo_hatamesaj: _message });
        }
        else {

            $("#cardNo").parent().removeClass("t-error");
            $("#cardNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
            this.setState({ cardNo_hatamesaj: "" });
        }
    }


    cardBinSearchEminPay() {
        const numericCardNumber = this.state.card_number.replace(/[\s-]/g, '');
        if (numericCardNumber.length > 7) {
            // sadece rakam uzunluğu 7'den büyükse burası çalışır
            binSearchEminPay(this.state.card_number).then(
                response => {
                    if (response.responseCode == 200 && response.data != null) {
                        if (response.data.brand == "none") {
                            this.cardNoControl("", "", "", "", "Bu kart ile taksitli işlem yapılamaz.", true);
                        } else {
                            this.cardNoControl(response.data.bank, response.data.bankCode, response.data.businessCard, response.data.brandPrivate, "", false);
                        }
                    } else {
                        if (response.messages.length > 0) {
                            this.cardNoControl("", "", "", "", response.messages[0], true);
                        } else {
                            this.cardNoControl("", "", "", "", "Geçersiz kart numarası.", true);
                        }
                    }
                },
                error => {
                    this.cardNoControl("", "", "", "", "Kart numarası sorgulanamadı.", true);
                }
            );
        } else {
            this.state.card_type = "";
            this.setState({ card_type: "" });
            this.state.bank = "";
            this.setState({ bank: "" });
            this.state.bankCode = "";
            this.setState({ bankCode: "" });
            this.state.businessCard = "";
            this.setState({ businessCard: "" });
            this.cardgetPaymentPlaneEminPay();
        }
    }

    cardAddPaymentEminPay() {

        this.props.creditcard.cardType = this.state.card_type;
        this.props.creditcard.bank = this.state.bank;
        this.props.creditcard.bankCode = this.state.bankCode;
        this.props.creditcard.businessCard = this.state.businessCard;
        this.props.createPaymentPayFor();
    }

    cardgetPaymentPlaneEminPay() {
        const { creditcard, orderdetail } = this.props;

        const numericCardNumber = this.state.card_number.replace(/[\s-]/g, '');
        if (numericCardNumber.length > 7) {
            getPaymentPlaneEminPay(this.state.card_number, this.state.amount, orderdetail.paymentType, this.state.card_type, orderdetail.memberNo).then(
                response => {
                    this.setState({ installment_list: response.data });
                    if (response.data.length > 0) {
                        if (orderdetail.paymentType == 1) {
                            this.state.installment_count = response.data[0].value;
                            this.props.orderdetail.installmentCount = response.data[0].value;
                        }
                        else {
                            this.state.installment_count = 0;
                            this.props.orderdetail.installmentCount = 0;
                        }
                    }
                    else if (response.messages != null && response.messages[0] != null) {

                        this.setState({ cardNo_hatamesaj: "Taksitler oluşturulamadı. " + response.messages[0] });
                    }
                    else {
                        this.props.orderdetail.installmentCount = -3;
                    }
                },
                error => { }
            );
        }
        else if (numericCardNumber.length > 1) {

            this.setState({ installment_list: [] });
            this.setState({ cardNo_hatamesaj: "Kart bilgilerini kontrol edin." });
        }
    }

    componentDidMount() {
        this.setState({ shouldAnimateCard: true });
        window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);

        const cardNo = $("#cardNo").val();
        this.state.card_number = cardNo;
        this.cardBinSearchEminPay();
    }

    setInstallment(event) {
        this.setState({ installment_count: parseFloat(event.target.value) });

        $('.installment-row.installment-chacked').removeClass('installment-chacked');
        document.querySelector('input[name="installment_count"]:checked').parentElement.parentElement.classList.add('installment-chacked');
    }

    render() {

        const { creditcard, orderdetail } = this.props;
        var dt = new Date();
        const yearArray = Array.from({ length: 16 }, (_, i) => dt.getFullYear() + i);

        this.state.amount = parseFloat(orderdetail.aylikTutar + '.' + orderdetail.aylikTutarOndalik)


        var page = this.state.page;
        if (page == "sms") {
            return (
                <div className="t-createPayment-page t-eminPayOrder-page t-eminPayOrder-smsPage">
                    <div className="t-eminPayOrder-smsFrameWrap">
                        <iframe
                            className="t-eminPayOrder-smsFrame"
                            title="Banka ödeme onayı"
                            width="100%"
                            height="640"
                            frameBorder="0"
                            src={"data:text/html," + encodeURIComponent(this.state.smsResponse)}
                        />
                    </div>
                </div>
            );
        }
        return (
            <EminPayPageLayout
                pageSubtitle="Kart bilgilerinizi güvenle girerek ödeme talimatını tamamlayın."
                cardTitle="Kart Bilgileri"
                stepBadge="Adım 3 / 4"
                paymentTypeLabel={getEminPayTypeLabel(orderdetail.paymentType)}
                activeStep={2}
                shouldAnimateCard={this.state.shouldAnimateCard}
            >
                <form className="t-resetPassword-form t-eminPayOrder-form" onSubmit={this.onSubmit} noValidate>
                    <EminPayServiceAlert inline />
                    <div className="t-eminPayOrder-cardNotice">
                        <strong>Kart bilgilerinizi girin</strong>
                        <p>
                            Kart bilgileriniz yalnızca bankanızda saklanır. Emin Üstün Holding dahil
                            bankanız haricinde kimse tarafından görülemez.
                        </p>
                    </div>
                    {this.state.error !== "" ? (
                        <div className="t-eminPayOrder-errorBanner">{this.state.error}</div>
                    ) : null}
                    <div className="t-eminPayOrder-formFields">




                        <div className="t-resetPassword-field">
                            <label htmlFor="cardAdi" className="t-resetPassword-label">Kart Sahibi</label>
                            <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap">
                                <span className="t-resetPassword-inputIcon" aria-hidden="true">
                                    <i className="t-icon-user1" />
                                </span>
                                <input
                                    type="text"
                                    id="cardAdi"
                                    name="cc_owner"
                                    maxLength="50"
                                    pattern="^\s*[a-zA-Z,ç,Ç,ğ,Ğ,ı,İ,ö,Ö,ş,Ş,ü,Ü,\s]+\s*$"
                                    title="Sadece türkçe karakter girmelisiniz."
                                    placeholder="Kartın üzerindeki ismi yazınız"
                                    value={creditcard.cardHolderName}
                                    onChange={(e) => {
                                        creditcard.cardHolderName = e.target.value;
                                        this.setState({ cc_owner: e.target.value });
                                    }}
                                />
                            </div>
                            {this.state.cardAdi_hatamesaj ? (
                                <p className="t-resetPassword-error">{this.state.cardAdi_hatamesaj}</p>
                            ) : null}
                        </div>

                        <div className="t-resetPassword-field">
                            <label htmlFor="cardNo" className="t-resetPassword-label">Kart Numarası</label>
                            <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap">
                                <span className="t-resetPassword-inputIcon" aria-hidden="true">
                                    {this.state.card_type == "" || this.state.card_type == "none" ? (
                                        <i className="t-icon-credit_card" />
                                    ) : (
                                        <img
                                            src={`https://www.paytr.com/img/odeme_sayfasi/${this.state.card_type.toLowerCase()}.png`}
                                            alt={this.state.card_type.toLowerCase()}
                                            width={40}
                                        />
                                    )}
                                </span>
                                <NumberFormat
                                    displayType="input"
                                    format="####-####-####-####"
                                    name="card_number"
                                    id="cardNo"
                                    className="cardNo"
                                    title="Hatalı kart numarası"
                                    value={creditcard.cardNumber}
                                    onChange={(e) => {
                                        this.state.card_number = e.target.value.trim();
                                        creditcard.cardNumber = e.target.value.trim();
                                        this.cardBinSearchEminPay();
                                    }}
                                />
                            </div>
                            {this.state.cardNo_hatamesaj ? (
                                <p className="t-resetPassword-error">{this.state.cardNo_hatamesaj}</p>
                            ) : null}
                        </div>

                        <div className="t-eminPayOrder-cardGrid">
                            <div className="t-resetPassword-field">
                                <label htmlFor="cardTarih" className="t-resetPassword-label">
                                    Son Kullanım Tarihi
                                </label>
                                <div
                                    className="t-resetPassword-inputWrap t-submitDemand-inputWrap t-eminPayOrder-expiryWrap"
                                    id="cardExpiry-wrap"
                                >
                                    <span className="t-resetPassword-inputIcon" aria-hidden="true">
                                        <i className="t-icon-calendar1" />
                                    </span>
                                    <EminPayCustomSelect
                                        id="cardTarih"
                                        className="t-eminPayCustomSelect--expiryMonth"
                                        value={creditcard.expirationMonth}
                                        options={Array.from({ length: 12 }, (_, i) => i + 1).map((item) => ({
                                            value: String(item),
                                            label: String(item),
                                        }))}
                                        onChange={(nextValue) => {
                                            creditcard.expirationMonth = nextValue;
                                            this.setState({ expiry_month: nextValue });
                                        }}
                                    />
                                    <EminPayCustomSelect
                                        id="cardTarihYıl"
                                        className="t-eminPayCustomSelect--expiryYear"
                                        value={creditcard.expirationYear}
                                        options={yearArray.map((item) => ({
                                            value: String(item),
                                            label: String(item),
                                        }))}
                                        onChange={(nextValue) => {
                                            creditcard.expirationYear = nextValue;
                                            this.setState({ expiry_year: nextValue });
                                        }}
                                    />
                                    <span className="t-eminPayFieldStatus" id="cardExpiry_status" aria-hidden="true" />
                                </div>
                                {this.state.cardTarih_hatamesaj ? (
                                    <p className="t-resetPassword-error">{this.state.cardTarih_hatamesaj}</p>
                                ) : null}
                            </div>

                            <div className="t-resetPassword-field">
                                <label htmlFor="cardCvv" className="t-resetPassword-label">CVV Kodu</label>
                                <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap">
                                    <span className="t-resetPassword-inputIcon" aria-hidden="true">
                                        <i className="t-icon-credit-card" />
                                    </span>
                                    <NumberFormat
                                        displayType="input"
                                        format="###"
                                        pattern="^[0-9]*$"
                                        type="password"
                                        id="cardCvv"
                                        name="cvv"
                                        className="cardCvv"
                                        maxLength="50"
                                        required
                                        value={creditcard.cvv}
                                        onChange={(e) => {
                                            creditcard.cvv = e.target.value;
                                            this.setState({ cvv: e.target.value });
                                        }}
                                    />
                                </div>
                                {this.state.cardCvv_hatamesaj ? (
                                    <p className="t-resetPassword-error">{this.state.cardCvv_hatamesaj}</p>
                                ) : null}
                            </div>
                        </div>

                        {orderdetail.paymentType == 2 ? (
                            <div className="t-resetPassword-field">
                                <span className="t-resetPassword-label">Ödeme Planı</span>
                                {this.state.installmentCount_hatamesaj ? (
                                    <p className="t-resetPassword-error">{this.state.installmentCount_hatamesaj}</p>
                                ) : null}
                                <div className="t-listPayments-tableWrap t-eminPayOrder-installmentWrap">
                                    <table className="t-listPayments-table t-eminPayOrder-installmentTable">
                                        <thead>
                                            <tr>
                                                <th scope="col" />
                                                <th scope="col">Taksit Sayısı</th>
                                                <th scope="col">Taksit Tutarı</th>
                                                <th scope="col">Toplam Ödeme</th>
                                            </tr>
                                        </thead>
                                        <tbody className="tableInstalment">
                                            {this.state.installment_list.length > 0
                                                ? this.state.installment_list.map((installment_item) => (
                                                      <tr
                                                          key={installment_item.count}
                                                          className={`installment-row ${installment_item.checked ? "installment-chacked" : ""}`}
                                                          onClick={(e) => {
                                                              const radio = e.currentTarget.querySelector('input[type="radio"]');
                                                              if (radio) {
                                                                  radio.checked = true;
                                                                  this.setState({ installment_count: parseFloat(radio.value) });
                                                                  orderdetail.installmentCount = parseFloat(radio.value);
                                                                  document.querySelectorAll(".installment-row.installment-chacked")
                                                                      .forEach((row) => row.classList.remove("installment-chacked"));
                                                                  e.currentTarget.classList.add("installment-chacked");
                                                              }
                                                          }}
                                                          style={{ cursor: "pointer" }}
                                                      >
                                                          <td className="text-center">
                                                              <input
                                                                  type="radio"
                                                                  value={installment_item.value}
                                                                  name="installment_count"
                                                                  defaultChecked={installment_item.checked}
                                                                  onChange={(e) => {
                                                                      this.setState({ installment_count: parseFloat(e.target.value) });
                                                                      orderdetail.installmentCount = parseFloat(e.target.value);
                                                                  }}
                                                              />
                                                          </td>
                                                          <td>{installment_item.count}</td>
                                                          <td>{installment_item.amount}</td>
                                                          <td>{installment_item.total}</td>
                                                      </tr>
                                                  ))
                                                : null}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : null}

                        <div className="t-eminPayOrder-formActions">
                            <button
                                type="button"
                                className="t-memberInfo-btn t-memberInfo-btn--secondary"
                                onClick={() => this.props.changePage(createPaymentPages.orderDetail)}
                            >
                                <i className="t-icon-arrow-left2" aria-hidden="true" />
                                <span>Geri</span>
                            </button>
                            <button type="submit" className="t-memberInfo-btn t-memberInfo-btn--primary">
                                <span>Devam</span>
                                <i className="t-icon-arrow-right2" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                </form>
                <div id="paytr_taksit_tablosu" />
            </EminPayPageLayout>
        );
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardEminPay)
